import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M8 12a4 4 0 100-8 4 4 0 000 8zM8 1.332v1.333M8 13.332v1.333M3.285 3.285l.94.94M11.773 11.773l.94.94M1.332 8h1.333M13.332 8h1.333M4.225 11.773l-.94.94M12.713 3.285l-.94.94" stroke="currentColor" stroke-width=".667" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export { symbol as default };
